import React from 'react';
import { navigate } from 'gatsby';
import PureForm from '@firsttable/web-components/organisms/Forms/CitySearchForm';
import withLocation from '../../../hocs/location';

const CitySearchForm = (props) => <PureForm navigate={navigate} {...props} />;

export default withLocation(CitySearchForm);
